export default __webpack_public_path__ + "static/media/8_google_pay.1f714a26.svg";